(() => {
  document.documentElement.classList.add("lk-js");

  /* ---------- shipping dates: local calendar, order +2, order +7 to +10 ---------- */
  function fmtRange(now, start, end, locale) {
    const day = (n) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: "short", day: "numeric" };
    if (b.getFullYear() !== now.getFullYear()) opts.year = "numeric";
    const f = new Intl.DateTimeFormat(locale, opts);
    return { a, b, text: start === end ? f.format(a) : f.formatRange ? f.formatRange(a, b) : f.format(a) + "–" + f.format(b) };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = document.documentElement.lang || "en-US";
    document.querySelectorAll("[data-lk-ship-date]").forEach((el) => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: "long" });
      el.setAttribute("aria-label", s === e ? full.format(r.a) : full.format(r.a) + " to " + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  window.addEventListener("pageshow", updateShipDates);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) updateShipDates(); });

  /* ---------- free gift: one gift line, free through the gift code, only while a phone is in the bag ---------- */
  const Gift = (() => {
    let cfg = null, pending = null;
    const base = () => window.Shopify?.routes?.root || "/";
    async function req(path, body, tries = 2) {
      const r = await fetch(base() + path, body
        ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
        : { headers: { Accept: "application/json" } });
      let d;
      try { d = JSON.parse(await r.text()); } catch {
        if (tries > 1) { await new Promise((z) => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error("Your bag is busy. Please try again in a moment.");
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || "Your bag could not be updated. Please try again.");
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req("cart.js");
      const isPack = (i) => cfg.packs.includes(Number(i.variant_id));
      const gifts = cart.items.filter((i) => Number(i.variant_id) === cfg.gift);
      const want = cart.items.some(isPack) ? 1 : 0;
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const own = cfg.code.toUpperCase();
      const others = codes.filter((c) => c.toUpperCase() !== own);
      const applied = codes.some((c) => c.toUpperCase() === own);
      const free = gifts.every((i) => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => (updates[g.key] = k === 0 ? want : 0));
      else if (want) updates[cfg.gift] = want;
      const drawer = document.querySelector("cart-drawer");
      const sections = drawer?.getSectionsToRender?.().map((s) => s.id) || [];
      cart = await req("cart/update.js", { updates, discount: [...others, ...(want ? [cfg.code] : [])].join(","), sections, sections_url: location.pathname });
      const charged = cart.items.filter((i) => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (want && charged.length) {
        const rm = {};
        charged.forEach((i) => (rm[i.key] = 0));
        cart = await req("cart/update.js", { updates: rm, sections, sections_url: location.pathname });
        if (drawer?.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error("Your lowkey is in your bag, but the free gift could not be applied. Please contact us before checkout.");
      }
      if (drawer?.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return {
      set(c) { cfg = c; },
      sync() { return pending || ((pending = reconcile().finally(() => (pending = null))), pending); },
    };
  })();
  window.LowkeyGift = Gift;

  const init = () => {
    updateShipDates();
    const secs = document.querySelectorAll(".lk-s[data-lk-reveal]");
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      }), { threshold: 0, rootMargin: "0px 0px -10% 0px" });
      secs.forEach((s) => io.observe(s));
    } else secs.forEach((s) => s.classList.add("is-in"));
    // anything already scrolled past (anchor jumps, restored scroll) is shown at once
    const catchUp = () => secs.forEach((s) => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add("is-in"); });
    addEventListener("scroll", () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();

    const root = document.querySelector("#lowkey");
    if (!root || root.dataset.ready) return;
    // compact reviews line reads "[Name] check [Name] check and 640+ ...": drop the comma between the names
    root.querySelectorAll(".lk-proof .ceyla-rproof__text").forEach((pEl) => pEl.childNodes.forEach((n) => {
      if (n.nodeType === 3 && n.textContent.trim() === ",") n.textContent = " ";
    }));
    root.dataset.ready = "1";
    const reduce = () => matchMedia("(prefers-reduced-motion:reduce)").matches;
    const buyBox = root.querySelector(".lk-buy");
    if (buyBox && !reduce()) {
      buyBox.classList.add("lk-pre");
      requestAnimationFrame(() => requestAnimationFrame(() => buyBox.classList.remove("lk-pre")));
    }
    const money = (c) => new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency: root.dataset.currency || "USD" }).format(c / 100);
    const tiers = [...root.querySelectorAll('[name="lk-tier"]')];
    const colors = [...root.querySelectorAll('[name="lk-color"]')];
    const variantMap = (r) => { try { return JSON.parse(r.dataset.variants || "{}"); } catch { return {}; } };
    let color = (colors.find((c) => c.checked) || colors[0])?.value || "";
    const tierInfo = (t, col = color) => {
      const r = tiers.find((x) => x.value === String(t)) || tiers[0];
      const m = variantMap(r), keys = Object.keys(m);
      const v = m[col] || m[keys[0]] || {};
      return { r, variant: Number(v.id), price: Number(v.price), compare: Number(v.compare || 0), available: v.available === true || v.available === "true" };
    };
    const allVariants = tiers.flatMap((r) => Object.values(variantMap(r)).map((v) => Number(v.id)));
    Gift.set({ packs: allVariants, gift: Number(root.dataset.giftVariant) || 0, code: root.dataset.giftCode || "LOWKEYGIFT" });

    /* gallery */
    const g = root.querySelector("[data-lk-gallery]");
    const slides = [...g.querySelectorAll(".lk-slide")];
    const thumbs = [...root.querySelectorAll(".lk-thumb")];
    const smooth = () => (reduce() ? "auto" : "smooth");
    const idx = () => Math.round(g.scrollLeft / g.clientWidth);
    const to = (i) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * g.clientWidth, behavior: smooth() });
    root.querySelectorAll("[data-lk-slide]").forEach((b) => b.addEventListener("click", () => to(Number(b.dataset.lkSlide))));
    root.querySelector("[data-lk-next]")?.addEventListener("click", () => to(idx() + 1));
    root.querySelector("[data-lk-prev]")?.addEventListener("click", () => to(idx() - 1));
    let raf;
    g.addEventListener("scroll", () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx();
        const ix = root.querySelector("[data-lk-index]");
        if (ix) ix.textContent = String(i + 1);
        thumbs.forEach((t, j) => { t.classList.toggle("is-on", i === j); t.setAttribute("aria-pressed", String(i === j)); });
      });
    }, { passive: true });
    g.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") { e.preventDefault(); to(idx() + (e.key === "ArrowRight" ? 1 : -1)); }
    });

    /* offer + color */
    let tier = Number(root.dataset.tier) || 1;
    const termsId = root.querySelector("[data-lk-terms-id]");
    const paint = () => {
      const t = tierInfo(tier);
      tiers.forEach((r) => {
        r.checked = r.value === String(tier);
        const card = r.closest(".lk-offer");
        card.classList.toggle("is-on", r.checked);
        const ti = tierInfo(r.value);
        const pp = card.querySelector("[data-lk-offer-price]"), pc = card.querySelector("[data-lk-offer-compare]");
        if (pp) pp.textContent = money(ti.price);
        if (pc) { pc.hidden = !(ti.compare > ti.price); pc.textContent = money(ti.compare); }
      });
      colors.forEach((c) => { c.checked = c.value === color; c.closest(".lk-swatch")?.classList.toggle("is-on", c.checked); });
      const cn = root.querySelector("[data-lk-color-name]");
      if (cn) cn.textContent = color;
      root.querySelector("[data-lk-price]").textContent = money(t.price);
      const c = root.querySelector("[data-lk-compare]"), s = root.querySelector("[data-lk-save]");
      if (c && s) {
        if (t.compare > t.price) { c.hidden = false; s.hidden = false; c.textContent = money(t.compare); s.textContent = "Save " + money(t.compare - t.price).replace(/\.00(?=\D*$)/, ""); }
        else { c.hidden = true; s.hidden = true; }
      }
      document.querySelectorAll("[data-lk-atc-total]").forEach((el) => (el.textContent = money(t.price)));
      const sp = document.querySelector("[data-lk-sticky-price]");
      if (sp) sp.textContent = money(t.price);
      document.querySelectorAll("[data-lk-tier-amount]").forEach((el) => (el.textContent = money(tierInfo(Number(el.dataset.lkTierAmount)).price)));
      if (termsId && termsId.value !== String(t.variant)) { termsId.value = t.variant; termsId.dispatchEvent(new Event("change", { bubbles: true })); }
      const main = root.querySelector(".lk-atc[data-lk-add]"), lbl = root.querySelector("[data-lk-add-label]");
      if (main) { main.disabled = !t.available; if (lbl) lbl.textContent = t.available ? main.dataset.label || lbl.textContent : "Sold out"; }
      if (t.variant) { const u = new URL(location.href); u.searchParams.set("variant", t.variant); history.replaceState(history.state, "", u); }
    };
    const mainLbl = root.querySelector("[data-lk-add-label]");
    if (mainLbl) root.querySelector(".lk-atc[data-lk-add]").dataset.label = mainLbl.textContent;
    tiers.forEach((r) => r.addEventListener("change", () => { tier = Number(r.value); paint(); }));
    colors.forEach((r) => r.addEventListener("change", () => {
      color = r.value; paint();
      const sl = Number(r.dataset.slide);
      if (Number.isFinite(sl) && sl >= 0 && r.dataset.slide !== "") to(sl);
    }));
    paint();
    window.addEventListener("pageshow", paint);

    async function drawerReady() {
      await customElements.whenDefined("cart-drawer");
      const d = document.querySelector("cart-drawer");
      if (!d || typeof d.renderContents !== "function") throw Error("The bag is still loading. Please try again.");
      return d;
    }
    const setCount = (n) => root.querySelectorAll("[data-lk-count]").forEach((e) => (e.textContent = n));
    const vipFirst = () => {
      const sheet = document.querySelector(".vf-root"), bag = document.querySelector("cart-drawer");
      if (!sheet || !bag || sheet.classList.contains("open")) return;
      const hide = { visibility: "hidden", opacity: "0", "pointer-events": "none", transition: "none" };
      Object.keys(hide).forEach((p) => bag.style.setProperty(p, hide[p], "important"));
      let ticks = 0;
      const tm = setInterval(() => {
        if (sheet.classList.contains("open") || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach((p) => bag.style.removeProperty(p)); }
      }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget;
      if (btn.dataset.lkTier) { tier = Number(btn.dataset.lkTier); paint(); }
      const t = tierInfo(tier);
      if (!t.available || !t.variant) return;
      busy = true;
      const buttons = [...document.querySelectorAll("[data-lk-add]")];
      buttons.forEach((b) => { b.disabled = true; b.setAttribute("aria-busy", "true"); });
      const err = root.querySelector("[data-lk-error]");
      err.textContent = "";
      try {
        const drawer = await drawerReady();
        drawer.setActiveElement && drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map((s) => s.id);
        const res = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: t.variant, quantity: 1 }], sections, sections_url: location.pathname }),
        });
        let data;
        try { data = JSON.parse(await res.text()); } catch { throw Error("Your lowkey could not be added. Please try again."); }
        if (!res.ok || data.status) throw Error(data.description || data.message || "Your lowkey could not be added. Please try again.");
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Gift.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch((window.Shopify?.routes?.root || "/") + "cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle("is-empty", cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || "Please check your bag before trying again.";
        err.scrollIntoView({ block: "center", behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach((b) => { b.removeAttribute("aria-busy"); b.disabled = false; });
        paint();
      }
    }
    document.querySelectorAll("[data-lk-add]").forEach((b) => b.addEventListener("click", add));
    root.querySelectorAll("[data-lk-cart]").forEach((b) => b.addEventListener("click", async () => {
      try {
        const d = await drawerReady();
        await Gift.sync();
        const ids = d.getSectionsToRender().map((s) => s.id), base = window.Shopify?.routes?.root || "/";
        const [sections, c] = await Promise.all([
          fetch(base + "?sections=" + ids.join(",")).then((r) => r.json()),
          fetch(base + "cart.js").then((r) => r.json()),
        ]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle("is-empty", c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector("[data-lk-error]").textContent = x.message; }
    }));
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__lkSync);
        window.__lkSync = setTimeout(() => Gift.sync().then((c) => c && setCount(c.item_count)).catch((x) => {
          const e = document.querySelector("#CartDrawer-CartErrors") || root.querySelector("[data-lk-error]");
          if (e) e.textContent = x.message;
        }), 150);
      });
    }
    const nd = document.querySelector("cart-drawer");
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll(".cart-drawer-item .quantity__input")];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains("is-empty")) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    document.addEventListener("click", (e) => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.lkReady === "1") return;
      e.preventDefault();
      e.stopImmediatePropagation();
      Gift.sync().then(() => {
        const n = document.querySelector('cart-drawer [name="checkout"]') || b;
        n.dataset.lkReady = "1"; n.click(); delete n.dataset.lkReady;
      }).catch((x) => {
        const el = document.querySelector("#CartDrawer-CartErrors") || root.querySelector("[data-lk-error]");
        if (el) el.textContent = x.message;
      });
    }, true);
    Gift.sync().then((c) => c && setCount(c.item_count)).catch(() => {});

    const dlg = document.querySelector("#lowkey-policy");
    if (dlg) {
      document.querySelectorAll("[data-lk-policy]").forEach((b) => b.addEventListener("click", () => dlg.showModal()));
      dlg.querySelector("[data-lk-close]").addEventListener("click", () => dlg.close());
      dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
    }
    const cBan = document.querySelector(".lk-banner"), cPill = document.querySelector(".lk-concept-pill");
    if (cPill) {
      if (cBan && "IntersectionObserver" in window) new IntersectionObserver((es) => cPill.classList.toggle("is-on", !es[0].isIntersecting)).observe(cBan);
      else cPill.classList.add("is-on");
    }
    const sticky = document.querySelector("[data-lk-sticky]"), buy = root.querySelector(".lk-buy .lk-atc");
    if (sticky && buy) {
      let sraf;
      const check = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle("is-on", show);
          sticky.setAttribute("aria-hidden", String(!show));
          sticky.querySelector("button").tabIndex = show ? 0 : -1;
        });
      };
      addEventListener("scroll", check, { passive: true });
      addEventListener("resize", check);
      check();
    }
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
  document.addEventListener("shopify:section:load", () => {
    updateShipDates();
    document.querySelectorAll(".lk-s[data-lk-reveal]").forEach((s) => s.classList.add("is-in"));
  });
})();

/* ---------- keypad demo: the real keys type, call, open and go home ---------- */
(() => {
  const T9 = { "2": "abc", "3": "def", "4": "ghi", "5": "jkl", "6": "mno", "7": "pqrs", "8": "tuv", "9": "wxyz", "0": "space", "1": "voicemail" };
  const setup = () => {
    document.querySelectorAll("[data-lk-demo]").forEach((d) => {
      if (d.dataset.ready) return;
      d.dataset.ready = "1";
      const views = {};
      d.querySelectorAll("[data-view]").forEach((v) => (views[v.dataset.view] = v));
      const digits = d.querySelector("[data-lk-digits]"), hint = d.querySelector("[data-lk-t9]"), calling = d.querySelector("[data-lk-calling]");
      const keyHint = d.querySelector(".lk-key-hint");
      let num = "", callTimer;
      const show = (name) => Object.entries(views).forEach(([k, v]) => v.classList.toggle("is-on", k === name));
      const flash = (b) => { b.classList.add("is-press"); setTimeout(() => b.classList.remove("is-press"), 140); };
      const press = (key) => {
        clearTimeout(callTimer);
        if (keyHint) keyHint.hidden = true;
        if (/^[0-9*#]$/.test(key)) {
          if (num.length >= 14) num = "";
          num += key;
          digits.textContent = num;
          hint.textContent = T9[key] ? key + " · " + T9[key] : "";
          show("dial");
        } else if (key === "call") {
          if (num) { calling.textContent = num; show("call"); callTimer = setTimeout(() => { num = ""; show("home"); }, 2600); }
          else show("recent");
        } else if (key === "end" || key === "ok") { num = ""; show("home"); }
        else if (key === "left") show("chats");
        else if (key === "right") show("social");
      };
      d.querySelectorAll("[data-key]").forEach((b) => b.addEventListener("click", () => { flash(b); press(b.dataset.key); }));
      d.querySelectorAll("[data-try]").forEach((b) => b.addEventListener("click", () => {
        const seq = b.dataset.try.split(",");
        seq.forEach((k, i) => setTimeout(() => {
          const kb = d.querySelector('[data-key="' + k + '"]');
          if (kb) flash(kb);
          press(k);
        }, i * 260));
      }));
      show("home");
    });
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", setup) : setup();
  document.addEventListener("shopify:section:load", setup);
})();

/* ---------- lock screen: show only the people ---------- */
(() => {
  const setup = () => {
    document.querySelectorAll("[data-lk-notify]").forEach((w) => {
      const b = w.querySelector("[data-lk-notify-toggle]");
      if (!b || b.dataset.ready) return;
      b.dataset.ready = "1";
      const label = b.querySelector("[data-lk-toggle-text]");
      b.addEventListener("click", () => {
        const on = b.getAttribute("aria-pressed") !== "true";
        b.setAttribute("aria-pressed", on ? "true" : "false");
        w.classList.toggle("is-lowkey", on);
        if (label) label.textContent = on ? (b.dataset.on || label.textContent) : (b.dataset.off || label.textContent);
      });
    });
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", setup) : setup();
  document.addEventListener("shopify:section:load", setup);
})();
